import { Action, ActionReducer, createReducer, on } from '@ngrx/store';
import {
  addBanners,
  loadAboutUs,
  loadBanners,
  loadCareer,
  loadContactDetails,
  loadPrivacyPolicy,
  loadSiteSetting,
  loadTermsCondition,
  removeBanner,
  startCmsFetch,
  stopCmsFetch,
  loadWebBanners,
  addWebBanners,
  removeWebBanner,
  loadTeamDetails,
  loadFaqDetails
} from '../actions/cms/cms.action';
import { CmsStore } from '../models/store/cms/cmsStore';

export const initialState: CmsStore = {
  fetching: false,
  data: {}
};

const cmsReducer: ActionReducer<CmsStore, Action> = createReducer(initialState,
  /** LOADER */
  on(startCmsFetch, (state) => ({
    ...state,
    fetching: true
  })),
  on(stopCmsFetch, (state) => ({
    ...state,
    fetching: false
  })),
  /** LOADER */

  /** CONTACT DETAILS */
  on(loadContactDetails, (state, { contactDetails }) => (
    {
      ...state,
      data: {
        ...state.data,
        contactDetails
      }
    })
  ),
  /** CONTACT DETAILS */
  on(loadPrivacyPolicy, (state, { privacyPolicy }) => (
    {
      ...state,
      data: {
        ...state.data,
        privacyPolicy
      }
    })
  ),
  on(loadTermsCondition, (state, { termsCondition }) => (
    {
      ...state,
      data: {
        ...state.data,
        termsAndConditions: termsCondition
      }
    })
  ),
  on(loadAboutUs, (state, { about }) => (
    {
      ...state,
      data: {
        ...state.data,
        about
      }
    })
  ),
  on(loadSiteSetting, (state, { siteSetting }) => (
    {
      ...state,
      data: {
        ...state.data,
        siteSetting
      }
    })
  ),
  on(loadCareer, (state, { career }) => (
    {
      ...state,
      data: {
        ...state.data,
        career
      }
    })
  ),
  on(loadBanners, (state, { banners }) => (
    {
      ...state,
      data: {
        ...state.data,
        banners
      }
    })
  ),
  on(loadWebBanners, (state, { webBanners }) => (
    {
      ...state,
      data: {
        ...state.data,
        webBanners
      }
    })
  ),
  on(addBanners, (state, { banner }) => (
    {
      ...state,
      data: {
        ...state.data,
        banners: [banner, ...(state.data.banners || [])]
      }
    })
  ),
  on(addWebBanners, (state, { webBanner }) => (
    {
      ...state,
      data: {
        ...state.data,
        banners: [webBanner, ...(state.data.webBanners || [])]
      }
    })
  ),
  on(loadTeamDetails, (state, { teamDetails, meta }) => (
    {
      ...state,
      data: {
        ...state.data,
        teamDetails: teamDetails,
        meta: meta
      }
    })
  ),
  on(loadFaqDetails, (state, { faqDetails, meta }) => (
    {
      ...state,
      data: {
        ...state.data,
        faqDetails: faqDetails,
        meta: meta
      }
    })
  ),
  // on(removeWebBanner, (state, {id}) => (

  //     {
  //       ...state,
  //       data: {
  //         ...state.data,
  //         webBanners: [id, ...(state.data.banners || [])]
  //       }
  //     })
  //   ),
  // on(removeBanner, (state, {id}) => (

  //   {
  //     ...state,
  //     data: {
  //       ...state.data,
  //       banners: [id, ...(state.data.banners || [])]
  //     }
  //   })
  // ),

);

export function reducer(state: CmsStore, action: Action) {
  return cmsReducer(state, action);
}
